/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:06726232-2f08-4bff-a66d-b2cd709dbc18",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_EWwwZMgzj",
    "aws_user_pools_web_client_id": "6qgs82bqud7moqfpuaahp4vik1",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "purecremationdidprod-20240910200551-hostingbucket-staging",
    "aws_content_delivery_bucket_region": "eu-west-2",
    "aws_content_delivery_url": "https://d3pbjuvh6afzk0.cloudfront.net"
};


export default awsmobile;
